<template>
  <ul
    class="
      row
      no-gutters
      mt-n2 c-sm:mt-n4 c-md:mt-n5 c-lg:mt-n6
      ml-n2 c-sm:ml-n4 c-md:ml-n5
      c-py-1 c-md:c-py-2 c-lg:c-py-3
      c-mb-0
      list-unstyled
    "
  >
    <li
      v-for="(item, key) in items"
      :key="key"
      class="col-12 c-lg:col-3 flex c-flex-col c-pt-2 c-sm:c-pt-4 c-md:c-pt-5 c-lg:c-pt-6 c-pl-2 c-sm:c-pl-4 c-md:c-pl-5"
    >
      <div
        class="
          row
          relative
          c-sm:c-items-center c-lg:c-items-start
          c-lg:c-justify-center
          c-px-1 c-sm:c-px-2 c-md:c-px-3
          c-flex-grow-1
          c-py-1
        "
      >
        <!-- obrazek -->
        <div class="col-4 c-sm:col-3 c-md:col-2 c-lg:col-6 c-xl:col-5 c-lg:c-mb-2">
          <div class="embed-responsive embed-responsive-1by1 c-mb-0 c-rounded-sm">
            <component
              :is="item.svg"
              class="embed-responsive-item c-p-2 c-lg:c-p-0 image-contain"
              :icon-alt="item.text"
            />
          </div>
        </div>
        <!-- text -->
        <div class="col-8 c-sm:col-9 c-md:col-10 c-lg:col-12 c-flex-grow-1 c-lg:text-center static">
          <div class="form-row">
            <div class="col-12 c-sm:col">
              <p class="c-mb-0 c-sm:c-mb-1 text-base-c font-medium">
                {{ item.text }}
              </p>
              <p class="c-mb-2 c-sm:c-mb-0 c-lg:c-mb-4 text-sm-c">
                {{ item.description }}
              </p>
            </div>
            <div class="col-12 c-sm:col-auto c-lg:col-12 static">
              <router-link
                :to="item.link"
                class="btn btn-outline-primary stretched-link c-py-1 c-sm:c-py-2 c-rounded-pill"
              >
                {{ t('i_want_to_subscribe') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>

<i18n>
  {
    "cs": {
    "i_want_to_subscribe": "Chci předplatit"
},
    "sk": {
    "i_want_to_subscribe": "Chcem predplatiť"
},
    "pl": {
    "i_want_to_subscribe": "Chcę się zapisać"
},
    "hu": {
    "i_want_to_subscribe": "Előfizetek"
},
    "de": {
    "i_want_to_subscribe": "Ich möchte abonnieren"
},
    "at": {
    "i_want_to_subscribe": "Ich möchte abonnieren"
},
    "ro": {
    "i_want_to_subscribe": "Doresc să mă abonez"
},
    "fr": {
    "i_want_to_subscribe": "Je souhaite m'abonner"
},
    "it": {
    "i_want_to_subscribe": "Voglio abbonarmi"
}
  }
</i18n>
